import { render, staticRenderFns } from "./EntregaDocumentos.vue?vue&type=template&id=1fb3df70"
import script from "./EntregaDocumentos.vue?vue&type=script&lang=js"
export * from "./EntregaDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb3df70')) {
      api.createRecord('1fb3df70', component.options)
    } else {
      api.reload('1fb3df70', component.options)
    }
    module.hot.accept("./EntregaDocumentos.vue?vue&type=template&id=1fb3df70", function () {
      api.rerender('1fb3df70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/EntregaDocumentos.vue"
export default component.exports